// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

ion-content {
  --background: white;
}

ion-fab {
  top: calc(24px + var(--ion-safe-area-top));
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: calc(var(--ion-safe-area-top) + 16px);
}

.header-content:last-child {
  position: relative;
  right: 10px;
  color: red;
  background-color: red;
}

.container {
  font-family: sans-serif;
  min-height: 100vh;
  max-width: min(1024px, 100%);
  margin: 0 auto;
  line-height: 1.4;
  padding: 20px 40px;
  background: white;
}

.heading-1 {
  font-size: 30px;
  text-transform: uppercase;
  color: var(--ion-color-primary-darker);
}

.sub-heading {
  font-size: 20px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 10px;
}

.sub-heading p {
  font-weight: 700;
  text-transform: capitalize;
  margin-right: 10px;
}

.sub-heading span {
  color: #555;
  font-weight: 300;
  border-right: 1px solid #ccc;
  padding-right: 10px;
}

.sub-heading .importent {
  color: crimson;
  text-transform: uppercase;
  font-weight: 300;
  padding-left: 10px;
}

p {
  color: var(--ion-color-primary-darker);
}

.heading-2 {
  font-size: 40px;
  line-height: 1.1;
  margin-top: 30px;
  color: var(--ion-color-primary-darker);
}

.home-img {
  width: 100%;
}

/* HOME */
.home {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 8px;
}

.article-image-image {
  height: 30vh;
  width: 100%;
}

@media (min-width: 992px) {
  swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .article-image-image {
    width: 100%;
    max-width: 800px;
    height: auto;
    max-height: 512px;
    object-fit: cover;
    object-position: center;
    display: block;
  }
}
/* ARTICLE */
article > p {
  font-size: 14px;
  margin: 20px 0;
  columns: 3 25ch;
  column-gap: 40px;
  -webkit-hyphens: auto;
          hyphens: auto;
  color: var(--ion-color-primary-darker);
}

article p:first-child::first-line {
  font-weight: 700;
  font-size: 25px;
}

@media (max-width: 950px) {
  .home {
    grid-template-columns: 1fr;
  }
}
@media (min-width: 950px) {
  .home {
    grid-template-columns: none;
  }
}
.article-category {
  font-size: 0.625rem;
  padding: 0.5rem;
  margin-right: 0.5rem;
  margin-top: 32px;
  margin-bottom: 8px;
}

.ripple-parent {
  position: relative;
  overflow: hidden;
}

ion-button {
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modals/news-details/news-details.component.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,0CAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iDAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;AACF;;AACA;EACE,uBAAA;EACA,iBAAA;EACA,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAEF;;AACA;EACE,eAAA;EACA,yBAAA;EACA,sCAAA;AAEF;;AACA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;AAEF;;AACA;EACE,gBAAA;EACA,0BAAA;EACA,kBAAA;AAEF;;AACA;EACE,WAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;AAEF;;AACA;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AAEF;;AACA;EACE,sCAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AACA,SAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;AAEF;;AACA;EACE,YAAA;EACA,WAAA;AAEF;;AAIA;EACE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;EADF;EAIA;IACE,WAAA;IACA,gBAAA;IACA,YAAA;IACA,iBAAA;IACA,iBAAA;IACA,uBAAA;IACA,cAAA;EAFF;AACF;AAKA,YAAA;AACA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;UAAA,aAAA;EACA,sCAAA;AAHF;;AAMA;EACE,gBAAA;EACA,eAAA;AAHF;;AAMA;EACE;IACE,0BAAA;EAHF;AACF;AAMA;EACE;IACE,2BAAA;EAJF;AACF;AAOA;EACE,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AALF;;AAQA;EACE,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AALF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nion-content {\n  --background: white;\n}\n\nion-fab {\n  top: calc(24px + var(--ion-safe-area-top));\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: calc(var(--ion-safe-area-top) + 16px);\n}\n\n.header-content:last-child {\n  position: relative;\n  right: 10px;\n  color: red;\n  background-color: red;\n}\n.container {\n  font-family: sans-serif;\n  min-height: 100vh;\n  max-width: min(1024px, 100%);\n  margin: 0 auto;\n  line-height: 1.4;\n  padding: 20px 40px;\n  background: white;\n}\n\n.heading-1 {\n  font-size: 30px;\n  text-transform: uppercase;\n  color: var(--ion-color-primary-darker);\n}\n\n.sub-heading {\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n}\n\n.sub-heading p {\n  font-weight: 700;\n  text-transform: capitalize;\n  margin-right: 10px;\n}\n\n.sub-heading span {\n  color: #555;\n  font-weight: 300;\n  border-right: 1px solid #ccc;\n  padding-right: 10px;\n}\n\n.sub-heading .importent {\n  color: crimson;\n  text-transform: uppercase;\n  font-weight: 300;\n  padding-left: 10px;\n}\n\np {\n  color: var(--ion-color-primary-darker);\n}\n\n.heading-2 {\n  font-size: 40px;\n  line-height: 1.1;\n  margin-top: 30px;\n  color: var(--ion-color-primary-darker);\n}\n\n.home-img {\n  width: 100%;\n}\n\n/* HOME */\n.home {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 8px;\n}\n\n.article-image-image{\n  height: 30vh;\n  width: 100%;\n}\n\n// Desktop — cap at 512px tall, full slide width.\n// Landscape images render naturally (auto height under the cap).\n// Portrait images get center-cropped to a landscape band via object-fit: cover.\n@media (min-width: 992px) {\n  swiper-slide {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .article-image-image {\n    width: 100%;\n    max-width: 800px;\n    height: auto;\n    max-height: 512px;\n    object-fit: cover;\n    object-position: center;\n    display: block;\n  }\n}\n\n/* ARTICLE */\narticle > p {\n  font-size: 14px;\n  margin: 20px 0;\n  columns: 3 25ch;\n  column-gap: 40px;\n  hyphens: auto;\n  color: var(--ion-color-primary-darker);\n}\n\narticle p:first-child::first-line {\n  font-weight: 700;\n  font-size: 25px;\n}\n\n@media (max-width: 950px) {\n  .home {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (min-width: 950px) {\n  .home {\n    grid-template-columns: none;\n  }\n}\n\n.article-category {\n  font-size: 0.625rem;\n  padding: 0.5rem;\n  margin-right: 0.5rem;\n  margin-top: 32px;\n  margin-bottom: 8px;\n}\n\n.ripple-parent {\n  position: relative;\n  overflow: hidden;\n}\n\nion-button {\n  --padding-start: 0;\n  --padding-end: 0;\n  --padding-top: 0;\n  --padding-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
